import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import { setError } from '../store/slices';
import { logoutAll } from '../store/actions';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: async (headers) => {
    try {
      const { tokens } = await fetchAuthSession({ forceRefresh: true });
      const accessToken = tokens?.accessToken?.toString() ?? '';
      headers.set('Authorization', `Bearer ${accessToken}`);
      return headers;
    } catch (error) {
      await signOut();
      throw new Error('FailedToAuth');
    }
  },
});
export const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  try {
    const result = await baseQuery(args, api, extraOptions);
    if (result.error) {
      api.dispatch(setError('ErrorOccured'));
      throw new Error('ErrorOccured');
    }
    return result;
  } catch (err: any) {
    // Handles auth token retrieval failures (prepareHeaders) and fetchBaseQuery errors
    if (err?.message === 'FailedToAuth') {
      api.dispatch(logoutAll() as any);
      api.dispatch(setError('FailedToAuth'));
    }
    throw err;
  }
};
